var React = require('react');

function ExtendedArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M32.1797 16.4138L31.0547 15.2413L37.6922 8.38272L31.0547 1.5241L32.1797 0.351685L39.9422 8.38272L32.1797 16.4138Z","fill":"black","key":0}),React.createElement("rect",{"y":"7.5","width":"38","height":"2","fill":"black","key":1})]);
}

ExtendedArrowInline.defaultProps = {"width":"40","height":"17","viewBox":"0 0 40 17","fill":"none"};

module.exports = ExtendedArrowInline;

ExtendedArrowInline.default = ExtendedArrowInline;
